import { Save } from "lucide-react";
import { TierInput } from "./parts";

// Annual amount configuration per member tier.
export const TierConfigForm = ({ tiers, setTiers, saving, onSubmit }) => (
  <form onSubmit={onSubmit} className="mt-10 bg-white border border-[hsl(var(--border))] p-6 sm:p-8" data-testid="quotas-config-form">
    <div className="overline">Valores anuais por nível</div>
    <p className="mt-2 text-sm text-[hsl(var(--muted-foreground))]">
      Pode ajustar os valores. Aplica-se imediatamente às quotas ainda não pagas.
    </p>
    <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
      <TierInput label="Sócio Aderente" tier="aderente" value={tiers.aderente}
        onChange={(v) => setTiers({ ...tiers, aderente: v })} testid="tier-aderente" />
      <TierInput label="Sócio Efetivo" tier="efetivo" value={tiers.efetivo}
        onChange={(v) => setTiers({ ...tiers, efetivo: v })} testid="tier-efetivo" />
      <TierInput label="Sócio Benemérito" tier="benemerito" value={tiers.benemerito}
        onChange={(v) => setTiers({ ...tiers, benemerito: v })} testid="tier-benemerito" />
      <TierInput label="Sócio Institucional" tier="institucional" value={tiers.institucional}
        onChange={(v) => setTiers({ ...tiers, institucional: v })} testid="tier-institucional" hint="Empresas/Organizações" />
      <TierInput label="Sócio Honorário" tier="honorario" value={tiers.honorario}
        onChange={(v) => setTiers({ ...tiers, honorario: v })} testid="tier-honorario" hint="0 € = isento" />
    </div>
    <div className="mt-6 flex justify-end">
      <button type="submit" disabled={saving}
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-[hsl(var(--primary))] text-white text-xs uppercase tracking-[0.18em] hover:bg-[#093630] disabled:opacity-60"
        data-testid="quotas-save-config">
        <Save className="h-4 w-4" /> {saving ? "A guardar…" : "Guardar valores"}
      </button>
    </div>
  </form>
);
